import { useMemo, useState } from "react"
import { Autocomplete, Stack, TextField } from "@mui/material"
import { skillMaps } from "routes/skill-mapper/controller/skill-maps"
import { tradeVocabulary } from "routes/skill-mapper/controller/trade-vocabulary"

export function ConditionValueTrade({ value, onChange }) {
    const selected = Array.isArray(value) ? value : value ? [value] : []
    const [selectedMap, setSelectedMap] = useState(null)

    const mapsResult = skillMaps.useResults({ skip: 0, take: 100, status: "active" })
    const mapOptions = useMemo(getMapOptions, [mapsResult])

    const trades = tradeVocabulary.useResults(selectedMap ? { skillMapId: selectedMap.id } : null)
    const tradeOptions = useMemo(getTradeOptions, [trades])

    return (
        <Stack spacing={1}>
            <Autocomplete
                options={mapOptions}
                getOptionLabel={getMapLabel}
                value={selectedMap}
                onChange={handleMapChange}
                renderInput={renderMapInput}
                isOptionEqualToValue={isOptionEqual}
            />
            <Autocomplete
                multiple
                freeSolo
                options={tradeOptions}
                value={selected}
                onChange={handleChange}
                renderInput={renderTradeInput}
            />
        </Stack>
    )

    function getMapOptions() {
        return mapsResult?.items ?? []
    }

    function getMapLabel(option) {
        return option?.name || ""
    }

    function isOptionEqual(option, val) {
        return option?.id === val?.id
    }

    function getTradeOptions() {
        return (trades ?? []).map((t) => t.name).sort()
    }

    function handleMapChange(_, val) {
        setSelectedMap(val)
    }

    function handleChange(_, newValue) {
        onChange(newValue)
    }

    function renderMapInput(params) {
        return <TextField {...params} placeholder="Pick a skill map to browse trades..." />
    }

    function renderTradeInput(params) {
        return (
            <TextField
                {...params}
                placeholder={selectedMap ? "Select trades..." : "Pick a skill map first, or type trade names..."}
            />
        )
    }
}
